<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card raised>
          <v-card-title class="display-1">Top 5 Products (Past 30 days)</v-card-title>
          <v-data-table
            :loading="loading"
            :items="products"
            :headers="productHeaders"
            :options="productPagination"
            hide-default-footer
            mobile-breakpoint="0"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ getProductSku(item)}}</td>
                <td>{{ item.name_zh_hk }}</td>
                <td>{{ item.sale.count || '-' }}</td>
                <td>{{ item.sale.amount ? item.sale.amount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
                  : '-' }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card raised>
          <v-card-title class="display-1">Top 5 Locations (Past 30 days)</v-card-title>
          <v-data-table
            :loading="loading"
            :items="locations"
            :headers="locationHeaders"
            :options="locationPagination"
            hide-default-footer
            mobile-breakpoint="0"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.name }}</td>
                <td>{{ item.sale.count || '-' }}</td>
                <td>{{ item.sale.amount ? item.sale.amount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
                  : '-' }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card raised>
          <v-card-title class="display-1">Sales (Past 6 months)</v-card-title>
          <v-data-table
            :loading="loading"
            :items="sales"
            :headers="saleHeaders"
            :options="salePagination"
            hide-default-footer
            mobile-breakpoint="0"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ getPeriodString(item.from, item.to) }}</td>
                <td>{{ item.count || '-' }}</td>
                <td>{{ item.amount ? item.amount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') : '-' }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import datetimeMixin from '@/mixins/datetime'
  import productMixin from '@/mixins/product'
  import paginationMixin from '@/mixins/pagination'

  export default {
    props: {
      dashboardService: Object
    },

    mixins: [
      datetimeMixin,
      productMixin,
      paginationMixin
    ],

    components: {
    },

    data () {
      return {
        loading: true,

        productHeaders: [
          {
            text: 'SKU',
            value: 'sku',
            align: 'left',
            sortable: false
          },
          {
            text: 'Product',
            value: 'name_zh_hk',
            align: 'left',
            sortable: false
          },
          {
            text: 'Number of Sales',
            value: 'sale.count',
            align: 'left',
            sortable: false
          },
          {
            text: 'Total Amount',
            value: 'sale.amount',
            align: 'left',
            sortable: false
          }
        ],

        locationHeaders: [
          {
            text: 'Location',
            value: 'name',
            align: 'left',
            sortable: false
          },
          {
            text: 'Number of Sales',
            value: 'sale.count',
            align: 'left',
            sortable: false
          },
          {
            text: 'Total Amount',
            value: 'sale.amount',
            align: 'left',
            sortable: false
          }
        ],

        saleHeaders: [
          {
            text: 'Date',
            value: 'from',
            align: 'left',
            sortable: false
          },
          {
            text: 'Number of Sales',
            value: 'count',
            align: 'left',
            sortable: false
          },
          {
            text: 'Total Amount',
            value: 'amount',
            align: 'left',
            sortable: false
          }
        ],

        products: [],
        locations: [],
        sales: []
      }
    },

    computed: {
      productPagination () {
        return Object.assign(this.pagination, {
          sortBy: ['sale.amount'],
          sortDesc: [true],
        })
      },
      locationPagination () {
        return Object.assign(this.pagination, {
          sortBy: ['sale.amount'],
          sortDesc: [true],
        })
      },
      salePagination () {
        return Object.assign(this.pagination, {
          sortBy: ['from'],
          sortDesc: [true],
        })
      },
    },

    created () {
      this.$store.commit('UPDATE_TITLE', '')

      this.dashboardService.list()
        .then(({ data }) => {
          const dashboardData = data.data
          this.products = dashboardData.products.slice(0, 5)
          this.locations = dashboardData.locations.slice(0, 5)
          this.sales = dashboardData.sales_monthly
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/Dashboard.vue